<template>
		<section class="card_list four_column square_image favourites" v-if="Object.keys(this.working_products).length > 0">
			<div class="constraint_narrow grid">
				<a :href="product.model.full_slug" class="list_item" v-for="(product, key) in working_products">
					<div class="image" :style="'background-image: url('+product.model.thumbnail_image+');'">
						<img :src="product.model.thumbnail_image" :alt="product.model.name" v-if="product.model.thumbnail_image">
					</div>
					<div class="text">
						<h2>{{ product.model.name }}</h2>
						<template v-if="product.model.display_price['selling_price'] > 0">
							<p>
								<template v-if="product.model.use_per_meter_pricing">
									from
									<b>&pound;{{ addVat(parseFloat(product.model.display_price['selling_from_price'])).toFixed(2) }}</b>
									<sup>*</sup>
									per m<sup><small>2</small></sup>
								</template>
								<template v-else>
									<template v-if="product.model.show_equivalent_price && product.model.display_price['variation_equivalent_m2'] > 0">
										<span class="equivalent">
											<template v-if="product.model.variations.length>1">
												from
											</template>
											<b>&pound;{{ addVat(parseFloat(product.model.display_price['variation_equivalent_m2'])).toFixed(2) }}</b><sup>*</sup> per m<sup><small>2</small></sup>
										</span>
										<template v-if="product.model.variations.length>1">
											(for {{ product.model.display_price['variation_name'] }} @ &pound;{{addVat(parseFloat(product.model.display_price['selling_price'])).toFixed(2)}}<sup>*</sup>&nbsp; )
										</template>
										<template v-else>
											&pound;{{ addVat(parseFloat(product.model.display_price['selling_price'])).toFixed(2) }}<sup>*</sup> &nbsp; per pack
										</template>
									</template>
									<template v-else>
										<template v-if="product.model.variations.length>1">
											from
										</template>
										<b>&pound;{{ addVat(parseFloat(product.model.display_price['selling_price'])).toFixed(2) }}</b><sup>*</sup>
										<br>(for {{ product.model.display_price['variation_name'] }})
									</template>
								</template>
								
							</p>
						</template>
						<template v-else>
							<p v-if="postcode == ''">Not currently available to buy online</p>
							<p v-else>Not available for delivery to <strong>{{ postcode }}</strong></p>
						</template>
						<template v-if="product.model.custom_sash">
							<span class="label">{{ product.model.custom_sash }}</span>
						</template>
						<p>
							<button type="button" class="button small solid remove" v-on:click.prevent="removeFromFavourites(key)"><i class="fas fa-trash-alt"></i>Remove</button>
						</p>
					</div>
				</a>
			</div>
		</section>
		<section class="generic_content" v-else>
			<div class="constraint">
				<p>You have no products in your wishlist.</p>
			</div>
		</section>
</template>
<script>
export default {

	props: [
		'products',
		'postcode'
	],

	data: () => {
		return {
			working_products: {},
			view: 'grid'
		}
	},

	created() {
		this.working_products = this.products
	},

	methods: {

		removeFromFavourites: function(key){
			axios.post('/box/wishlist/removeModel', {
				Model_Type: '\\App\\Product',
				Model_Id: this.working_products[key].model.id,
			}).then((response) => {
				this.working_products.splice(key, 1);
			});
		},

		addVat: function(num) {
			var rate = process.env.MIX_VAT_RATE;
			var multiply_by = 1 + (rate / 100);
			return num * multiply_by;
		}
	}

};
</script>